import React from 'react';
import { useBlockNumber, Web3Context } from '@sc1/common/hooks';

export const Web3Provider = ({ children }: { children: any }): JSX.Element => {
  const block = useBlockNumber();
  return (
    <Web3Context.Provider value={{ block }}>{children}</Web3Context.Provider>
  );
};
